import PropTypes from 'prop-types';

export const propTypes = {
    onAddShape: PropTypes.func,
    languageLocale: PropTypes.string,
};
